import {
  Directive,
  OnChanges,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  input
} from "@angular/core";
import { FeatureAppService } from "../services/feature-app.service";

@Directive({
  selector: "[appIsFeatureApp]",
})
export class IsFeatureAppDirective implements OnInit, OnChanges {
  readonly appIsFeatureApp = input<boolean | "">("");

  private hasView = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureAppService: FeatureAppService
  ) {}

  private updateView() {
    const appIsFeatureApp = this.appIsFeatureApp();
    const isFeatureApp = appIsFeatureApp === "" ? true : appIsFeatureApp;
    const condition = this.featureAppService.isFeatureApp === isFeatureApp;
    if (condition && this.hasView !== true) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!condition && this.hasView !== false) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  ngOnChanges() {
    this.updateView();
  }
  ngOnInit() {
    this.updateView();
  }
}

@Directive({
  selector: "[appIsNotFeatureApp]",
})
export class IsNotFeatureAppDirective implements OnInit, OnChanges {
  readonly appIsNotFeatureApp = input<boolean | "">("");

  private hasView = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureAppService: FeatureAppService
  ) {}

  private updateView() {
    const appIsNotFeatureApp = this.appIsNotFeatureApp();
    const isFeatureApp =
      appIsNotFeatureApp === "" ? false : !appIsNotFeatureApp;
    const condition = this.featureAppService.isFeatureApp === isFeatureApp;
    if (condition && this.hasView !== true) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!condition && this.hasView !== false) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  ngOnChanges() {
    this.updateView();
  }
  ngOnInit() {
    this.updateView();
  }
}
